import React from 'react';
import { MoneyhouseMedium, DocumentSmall, StatsSmall } from '@blueprint/icons';
import { CTALink } from 'listing-details/components/CTA/CTA';
import Gallery from 'shared/components/Gallery/Gallery';
import { EnergyPerfCertProps } from './EnergyPerfCert.types';
import { mapPropertyImageResponseToGalleryImages } from 'listing-details/helpers';
import {
    mapFilesToExternal,
    isImageNotPDF,
    isPDF
} from './EnergyPerfCert.helpers';
import {
    ModalGalleryContainer,
    EnergyPerfCertExternalList,
    EnergyPerfCertExternalItem
} from './EnergyPerfCert.styles';
import {
    trackNextEnergyPerfCert,
    trackPreviousEnergyPerfCert,
    trackZoomEnergyPerfCert,
    trackEnergyPerfCertExternalItemClick
} from './EnergyPerfCert.tracking';

const EnergyPerfCert = ({ data }: EnergyPerfCertProps) => {
    const { epc } = data;
    const images = mapPropertyImageResponseToGalleryImages(
        '(min-width: 1500px) 1280px, (min-width: 960px) 85vw, 100vw',
        epc?.image || []
    );

    const externalFiles = mapFilesToExternal(epc?.pdf || [], epc?.image || []);

    if (isImageNotPDF(data)) {
        return (
            <ModalGalleryContainer>
                <Gallery
                    images={images}
                    icon={<MoneyhouseMedium />}
                    createCaption={(index, total) =>
                        `Energy Perf Cert ${index + 1} of ${total}. ${
                            images[index].alt
                        }`
                    }
                    hasZoomControls={true}
                    onSlideNext={trackNextEnergyPerfCert}
                    onSlidePrevious={trackPreviousEnergyPerfCert}
                    onSlideZoom={trackZoomEnergyPerfCert}
                />
            </ModalGalleryContainer>
        );
    }

    if (isPDF(data)) {
        return (
            <EnergyPerfCertExternalList data-testid="files-list">
                {externalFiles.map((item, index) => (
                    <EnergyPerfCertExternalItem key={item.url}>
                        <CTALink
                            href={item.url}
                            target="_blank"
                            label={
                                item.caption || 'Energy Performance Certificate'
                            }
                            icon={<MoneyhouseMedium />}
                            iconAction={
                                item.type === 'pdf' ? (
                                    <DocumentSmall data-testid="icon-pdf" />
                                ) : (
                                    <StatsSmall data-testid="icon-img" />
                                )
                            }
                            onClick={() =>
                                trackEnergyPerfCertExternalItemClick(
                                    index,
                                    item.type
                                )
                            }
                        />
                    </EnergyPerfCertExternalItem>
                ))}
            </EnergyPerfCertExternalList>
        );
    }

    return <></>;
};

export default EnergyPerfCert;
